import { render, staticRenderFns } from "./Ninety_percent.vue?vue&type=template&id=5ec6286d&scoped=true"
import script from "./Ninety_percent.vue?vue&type=script&lang=js"
export * from "./Ninety_percent.vue?vue&type=script&lang=js"
import style0 from "./Ninety_percent.vue?vue&type=style&index=0&id=5ec6286d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6286d",
  null
  
)

export default component.exports